export function enforceExhaustive(value: never): never {
  return value;
}

export const isDashRoute = (route: string): boolean => {
  const DASH_HOSTNAMES = [
    "dash.ai",
    "www.dash.ai",
    "staging.dash.ai",
    "web-master.d7kgc1ikry9m3.amplifyapp.com",
    "localhost",
  ];

  return DASH_HOSTNAMES.some((host) => route.includes(host));
};

export const isPostExtensionInstallPage = (
  route: string | undefined,
): boolean => {
  return Boolean(
    route && isDashRoute(route) && route.includes("post-extension-install"),
  );
};
